function pagination(isInfinite = true, done, isMasonry = false) {
    const feedElement = document.querySelector('.gh-feed');
    if (!feedElement) return;

    let loading = false;
    // Set by the reader's own scrolling (wheel, touch, keys), see onScroll
    let readerScrolled = false;
    const target = document.querySelector('.gh-footer');
    // Start loading while the footer is still about two screens below the
    // viewport, so the next page is in before the reader reaches the end
    const lookahead = Math.max(1500, window.innerHeight * 2);
    const isNear = () => target.getBoundingClientRect().top <= window.innerHeight + lookahead;
    const buttonElement = document.querySelector('.gh-loadmore');

    if (!document.querySelector('link[rel=next]') && buttonElement) {
        buttonElement.remove();
    }

    const loadNextPage = async function () {
        const nextElement = document.querySelector('link[rel=next]');
        if (!nextElement) return;

        try {
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const postElements = doc.querySelectorAll('.gh-feed:not(.gh-featured):not(.gh-related) > *');
            const fragment = document.createDocumentFragment();
            const elems = [];

            postElements.forEach(function (post) {
                var clonedItem = document.importNode(post, true);

                if (isMasonry) {
                    clonedItem.style.visibility = 'hidden';
                }

                // Chrome ignores sizes="auto, …" (post-card.hbs) on imported cards
                // and took 100vw, so a 300px card fetched the 2000w file; the
                // measured list after "auto," picks the same file as on page 1
                clonedItem.querySelectorAll('img[sizes^="auto"]').forEach(function (img) {
                    img.sizes = img.sizes.replace(/^auto,\s*/, '');
                });

                fragment.appendChild(clonedItem);
                elems.push(clonedItem);
            });

            feedElement.appendChild(fragment);

            if (done) {
                done(elems, loadNextWithCheck);
            }

            // An empty page means the feed is done even if the collection has more
            // pages (the home feed leaves out video posts, see post-list.hbs)
            const resNextElement = postElements.length ? doc.querySelector('link[rel=next]') : null;
            // The crawlable "Older articles" link (post-list.hbs) follows along
            const moreLink = document.querySelector('.gh-more-next');
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;
                if (moreLink) moreLink.querySelector('a').href = resNextElement.href;
            } else {
                nextElement.remove();
                if (buttonElement) {
                    buttonElement.remove();
                }
                if (moreLink) moreLink.remove();
            }
        } catch (e) {
            nextElement.remove();
            throw e;
        }
    };

    const loadNextWithCheck = async function () {
        if (isNear() && document.querySelector('link[rel=next]')) {
            await loadNextPage();
        }
    }

    // Keep loading until the footer is out of reach or the last page is in, as
    // long as each page pushes the footer down. A jump to the end (End, a fling,
    // dragging the scrollbar) leaves the footer on screen, and scroll anchoring
    // then holds it there while cards go in above it, so this went on through
    // every page (24 on /articles/); now it's one page, then one per scroll
    const fill = async function () {
        loading = true;
        readerScrolled = false;

        try {
            if (!isMasonry) {
                while (isNear() && document.querySelector('link[rel=next]')) {
                    const top = target.getBoundingClientRect().top;
                    await loadNextPage();
                    if (target.getBoundingClientRect().top <= top) break;
                }
            } else {
                await loadNextPage();
            }
        } finally {
            loading = false;
        }

        if (!document.querySelector('link[rel=next]')) {
            observer.disconnect();
            window.removeEventListener('scroll', onScroll);
        }
    };

    const callback = function (entries) {
        if (loading) return;

        if (entries[0].isIntersecting) {
            fill();
        }
    };

    // The observer only fires as the footer comes into range, so once a load
    // has stopped with the footer still in range (above), the reader's next
    // scroll carries on. Only theirs: scroll anchoring scrolls the page too, as
    // cards go in and as the sticky header shrinks, and that would start the
    // run of loads again
    const markScrolled = function () {
        readerScrolled = true;
    };

    const onScroll = function () {
        if (loading || !readerScrolled) return;

        if (isNear() && document.querySelector('link[rel=next]')) {
            fill();
        }
    };

    const observer = new IntersectionObserver(callback, {rootMargin: `0px 0px ${lookahead}px 0px`});

    if (isInfinite) {
        observer.observe(target);
        window.addEventListener('scroll', onScroll, {passive: true});
        ['wheel', 'touchmove', 'keydown'].forEach(function (type) {
            window.addEventListener(type, markScrolled, {passive: true});
        });
    } else {
        buttonElement.addEventListener('click', loadNextPage);
    }
}
